<script>
import DidoMillesime from "./components/Millesime.vue";

export default {
  name: "DidoMillesimeCe",
  components: {
    DidoMillesime,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoDatafileRid: { type: String, required: true },
    didoDatafileMillesime: { type: String, required: false, default: void 0 },
    didoInitialFilter: { type: String, required: false, default: null },
  },
  emits: [
    "millesime-retrieved",
    "millesime-not-retrieved",
    "bad-configuration",
  ],
  template: `
    <DidoMillesime
      :api-url="didoUrl"
      :datafile-rid="didoDatafileRid"
      :datafile-millesime="didoDatafileMillesime"
      :initial-filter="didoInitialFilter"
      @millesime-retrieved="$emit('millesime-retrieved', $event)"
      @millesime-not-retrieved="$emit('millesime-not-retrieved', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
